export default class ExportService {
    constructor($http, appConfig, $window) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
      this.$window = $window;
    }
  
    exportReport(reportName, criteria) {
      const frm = $('#frmPrint');
      frm.attr('action', this.appConfig.apiServiceBaseUri + `api/export/report/${reportName}`);    
      $('#postdata').val(JSON.stringify(criteria));
      frm.submit();      
    }  
  
    serialize(obj) {
      var str = [];
      for (var p in obj)
        if (obj.hasOwnProperty(p)) {
          if (Array.isArray(obj[p])){
            obj[p].map(item => {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
            })          
          }
          else{
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
          
        }
      return str.join("&");
    }
  }
  


// WEBPACK FOOTER //
// ./client/app/common/services/export.service.js